webpackJsonp([1],{

/***/ 184:
/***/ (function(module, exports) {

module.exports = {"ronda-1":"Round 1","ronda-2":"Round 2","ronda-3":"Round 3","instrucciones":"Instructions"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.8c0e6efecd0aebac0816.js